<mat-card class="mat-elevation-z0 custom_outline">
  <mat-card-header>
    <mat-card-title>INCIDENT DETAILS</mat-card-title>
  </mat-card-header>
  <form>
    <mat-grid-list cols="4" rowHeight="100px">

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; padding: 3px;" >
          <mat-label>Case Number *</mat-label>
          <input matInput [disabled]="true" [(ngModel)]="data.CaseNumber" name="CaseNumber" autocapitalize="characters" [matTooltip]="'Original Agency Case Number Or BRASSTRAX Original Agency Reference Number'">
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; padding: 3px;">
          <mat-label>Date of Occurrence: *</mat-label>
          <input matInput [matDatepicker]="OccurrenceDatePicker" [(ngModel)]="data.OccurrenceDate" name="DTOFOCC" disabled>
          <mat-datepicker-toggle matSuffix [for]="OccurrenceDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #OccurrenceDatePicker></mat-datepicker>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
          <mat-label>Time of Occurrence: (HH:MM)</mat-label>
          <input matInput [(ngModel)]="data.OccurrenceTime" mask="Hh:m0" [leadZeroDateTime]="true" name="IncTimeOfOccurrence" [matTooltip]="'Time Format HH:MM'">
        </mat-form-field>

      </mat-grid-tile>

    </mat-grid-list>

    <mat-grid-list cols="4" rowHeight="80px">

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>Agency *</mat-label>
          <input type="text" [disabled]="true" matInput [(ngModel)]="data.Dept" name="nibinIncidentAgencyAutoComplete"  >
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; padding: 3px;" >
          <mat-label>Original Agency Ref # *</mat-label>
          <input matInput [disabled]="true" [(ngModel)]="data.LabNumber" name="LabNumber" autocapitalize="characters" [matTooltip]="'Agency Case Number Or BRASSTRAX Case Number'">
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="4" rowHeight="80px">

      <mat-grid-tile [colspan]="1" [rowspan]="1">
          <mat-form-field appearance="fill" style="width: 100%; padding: 3px;" >
            <mat-label>Incident Type</mat-label>
            <input matInput [disabled]="true" [(ngModel)]="data.Inc_Type" name="LabNumber" autocapitalize="characters" [matTooltip]="'Agency Case Number Or BRASSTRAX Case Number'">
          </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;" >
          <mat-label>Case Event Type</mat-label>
          <mat-select [(value)]="tempCaseEvent" multiple >
            <mat-option (onSelectionChange)="selectCaseEventChange($event)" *ngFor="let ddlItem of ddls.RelatedArea" [value]="ddlItem.DDL_Desc"  [matTooltip]="ddlItem.DDL_Hover">
              {{ddlItem.DDL_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>

    </mat-grid-list>

    <mat-grid-list cols="2" rowHeight="80px">
      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
          <mat-label>Incident Address</mat-label>
          <input matInput [(ngModel)]="data.Inc_Location" name="location" autocapitalize="characters">
        </mat-form-field>

      </mat-grid-tile>
    </mat-grid-list>

    <mat-grid-list cols="4" rowHeight="80px">

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;" >
          <mat-label>Incident State</mat-label>
          <input matInput [disabled]="true" [(ngModel)]="data.Inc_State" name="State" autocapitalize="characters">
        </mat-form-field>

      </mat-grid-tile>



      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
          <mat-label>Incident County *</mat-label>

          <input type="text" matInput [(ngModel)]="data.County" [matAutocomplete]="nibinIncidentCountyAutoComplete" name="nibinIncidentCountyAutoComplete" [formControl]="CNTRL_INC_COUNTY">
          <mat-autocomplete #nibinIncidentCountyAutoComplete="matAutocomplete" autoActiveFirstOption (optionSelected)="updateCityAgencyList()">
            <mat-option *ngFor="let c of FLTR_INC_COUNTY | async" [value]="c.County">
              {{c.County}}
            </mat-option>
          </mat-autocomplete>

          <button mat-button mat-icon-button matSuffix (click)="clearIncidentCounty()" *ngIf="data.County">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
          <mat-label>Incident City *</mat-label>
          <input type="text" matInput [(ngModel)]="data.Inc_City" [matAutocomplete]="nibinIncidentCityAutoComplete" name="nibinIncidentCityAutoComplete" [formControl]="CNTRL_INC_CITY">
          <mat-autocomplete #nibinIncidentCityAutoComplete="matAutocomplete" autoActiveFirstOption >
            <mat-option *ngFor="let c of FLTR_INC_CITY | async" [value]="c.City">
              {{c.City}}
            </mat-option>
          </mat-autocomplete>

          <button mat-button mat-icon-button matSuffix (click)="clearIncidentCity()" *ngIf="data.Inc_City">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </mat-grid-tile>


    </mat-grid-list>

  </form>
</mat-card>

<mat-card style="margin-top: 20px;" class="mat-elevation-z0 custom_outline">
  <mat-card-header>
    <mat-card-title>EVIDENCE DETAILS</mat-card-title>
  </mat-card-header>

  <mat-card class="custom_outline2">
    <h2>Linked Weapon</h2>

    <form>


      <mat-card *ngFor="let weapon of data.Weapon" class="mat-elevation-z0 custom_outline" style="margin: 10px;">
        <form>
          <mat-grid-list cols="4" rowHeight="100px">

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>MANUFACTURER *</mat-label>
                <input matInput [(ngModel)]="weapon.MAKE" name="Make" autocapitalize="characters">
                <mat-hint></mat-hint>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>MODEL *</mat-label>
                <input matInput [(ngModel)]="weapon.MODEL" name="MODEL" autocapitalize="characters">
                <mat-hint></mat-hint>
              </mat-form-field>

            </mat-grid-tile>


            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Caliber *</mat-label>
                <mat-select [(value)]="weapon.CALIBER">
                  <mat-option *ngFor="let ddlItem of ddls.Caliber" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                    {{ddlItem.DDL_Desc}}
                  </mat-option>
                </mat-select>
                <mat-hint></mat-hint>
              </mat-form-field>

            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Classification *</mat-label>
                <mat-select [(value)]="weapon.W_CLASS">
                  <mat-option *ngFor="let ddlItem of ddls.WeaponClassification" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                    {{ddlItem.DDL_Desc}}
                  </mat-option>
                </mat-select>
                <mat-hint></mat-hint>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Serial</mat-label>
                <input matInput [(ngModel)]="weapon.SERIAL_NUMBER" name="serial" autocapitalize="characters">
                <mat-hint></mat-hint>
              </mat-form-field>

            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Exhibit Marker</mat-label>
                <input matInput [(ngModel)]="weapon.EvidenceMarker" name="marker" autocapitalize="characters">
                <mat-hint></mat-hint>
              </mat-form-field>

            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Date of Collection:</mat-label>
                <input matInput [matDatepicker]="WPNDTOFCOLDatePicker" [(ngModel)]="weapon.DTOFCOLLECTION" name="DTOFCOL">
                <mat-datepicker-toggle matSuffix [for]="WPNDTOFCOLDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #WPNDTOFCOLDatePicker></mat-datepicker>
                <mat-hint></mat-hint>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;" >

                <input matInput [matDatepicker]="WPNDTOFSUBDatePicker" [(ngModel)]="weapon.DTOFSUBMISSION" name="DTOFSUB">
                <mat-datepicker-toggle matSuffix [for]="WPNDTOFSUBDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #WPNDTOFSUBDatePicker></mat-datepicker>
                <mat-label>Date of Submission:</mat-label>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1" dense>
              <mat-checkbox [checked]="weapon.CT_Ghost_Gun" (change)="setWeaponCheck($event.checked, weapon)">
                Ghost Gun
              </mat-checkbox>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1" dense>
              <mat-checkbox [checked]="weapon.SearModifyFlag" (change)="setSearModifyFlag($event.checked, weapon)">
                Sear Modified
              </mat-checkbox>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="4" [rowspan]="1" dense>
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
                <mat-label>Notes</mat-label>
                <input matInput [(ngModel)]="weapon.Notes" name="notes" autocapitalize="characters">
              </mat-form-field>

            </mat-grid-tile>

          </mat-grid-list>




          <button mat-button (click)="deleteWeaponRecord(weapon)" style="color:red;" *ngIf="!weapon.ID">DELETE</button>
        </form>
      </mat-card>

      <button mat-button (click)="addWeaponRecord()" >+ Add Weapon</button>
      <mat-card  class="mat-elevation-z0 custom_outline">
        <h5>
          Additional weapons can be added here but will not be linked to or the subject of this hit.  Added Weapons will have the same fields, they can be added or deleted at will.  If they appear they must be yellow and mandatory. If not, they must be deleted.
        </h5>
      </mat-card>
    </form>
  </mat-card>

  <mat-card class="custom_outline2" style="margin-top:2em;">
    <h2>Linked Cartridge Cases</h2>

    <form>


      <mat-card *ngFor="let ballistic of data.Ballistics" class="mat-elevation-z0 custom_outline" style="margin: 10px;">
        <form *ngIf="ballistic.VGID_CPart?.toUpperCase() === 'Cartridge Case'.toUpperCase()">
          <mat-grid-list cols="5" rowHeight="75px">

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Quantity in Cluster</mat-label>
                <input matInput [(ngModel)]="ballistic.Item_Quantity" name="Qty" mask="999">
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Caliber</mat-label>
                <mat-select [(value)]="ballistic.Caliber_Type">
                  <mat-option *ngFor="let ddlItem of ddls.Caliber" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                    {{ddlItem.DDL_Desc}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Marker(EVID/TFID)</mat-label>
                <input matInput [(ngModel)]="ballistic.EvidenceMarker" name="Marker" autocapitalize="characters">
              </mat-form-field>
            </mat-grid-tile>





            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Date of Collection:</mat-label>
                <input matInput [matDatepicker]="BALDTOFCOLDatePicker" [(ngModel)]="ballistic.DTOFCOLLECTION" name="BALDTOFCOL">
                <mat-datepicker-toggle matSuffix [for]="BALDTOFCOLDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #BALDTOFCOLDatePicker></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Date of Submission:</mat-label>
                <input matInput [matDatepicker]="BALDTOFSUBDatePicker" [(ngModel)]="ballistic.DTOFSUBMISSION" name="BALDTOFSUB">
                <mat-datepicker-toggle matSuffix [for]="BALDTOFSUBDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #BALDTOFSUBDatePicker></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="5" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
                <mat-label>Notes</mat-label>
                <input matInput [(ngModel)]="ballistic.Notes" name="Notes" >
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </form>

        <form *ngIf="ballistic.VGID_CPart?.toUpperCase() === 'Projectile'.toUpperCase()">
          <mat-grid-list cols="7" rowHeight="75px">

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Quantity in Cluster</mat-label>
                <input matInput [(ngModel)]="ballistic.Item_Quantity" name="Qty" mask="999">
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
                <mat-label>Caliber</mat-label>
                <mat-select [(value)]="ballistic.Caliber_Type">
                  <mat-option *ngFor="let ddlItem of ddls.Caliber" [value]="ddlItem.DDL_Desc" [matTooltip]="ddlItem.DDL_Hover">
                    {{ddlItem.DDL_Desc}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
                <mat-label>CL-L&G</mat-label>
                <mat-select [(value)]="ballistic.CL_LG">
                  <mat-option [value]="'1'" >1</mat-option>
                  <mat-option [value]="'2'" >2</mat-option>
                  <mat-option [value]="'3'" >3</mat-option>
                  <mat-option [value]="'4'" >4</mat-option>
                  <mat-option [value]="'5'" >5</mat-option>
                  <mat-option [value]="'6'" >6</mat-option>
                  <mat-option [value]="'7'" >7</mat-option>
                  <mat-option [value]="'8'" >8</mat-option>
                  <mat-option [value]="'9'" >9</mat-option>
                  <mat-option [value]="'10'" >10</mat-option>
                  <mat-option [value]="'11'" >11</mat-option>
                  <mat-option [value]="'12'" >12</mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
                <mat-label>CL-Twist</mat-label>
                <mat-select [(value)]="ballistic.CL_Twist">
                  <mat-option [value]="'LEFT'" >Left</mat-option>
                  <mat-option [value]="'RIGHT'" >Right</mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
                <mat-label>CL-Type</mat-label>
                <mat-select [(value)]="ballistic.CL_Type">
                  <mat-option [value]="'CONVENTIONAL'" >Conventional</mat-option>
                  <mat-option [value]="'POLY'" >Poly</mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>



            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Date of Collection:</mat-label>
                <input matInput [matDatepicker]="BALDTOFCOLDatePicker" [(ngModel)]="ballistic.DTOFCOLLECTION" name="BALDTOFCOL">
                <mat-datepicker-toggle matSuffix [for]="BALDTOFCOLDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #BALDTOFCOLDatePicker></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="1" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightyellow; border: 1px solid black; border-radius: 5px;">
                <mat-label>Date of Submission:</mat-label>
                <input matInput [matDatepicker]="BALDTOFSUBDatePicker" [(ngModel)]="ballistic.DTOFSUBMISSION" name="BALDTOFSUB">
                <mat-datepicker-toggle matSuffix [for]="BALDTOFSUBDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #BALDTOFSUBDatePicker></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="7" [rowspan]="1">
              <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
                <mat-label>Notes</mat-label>
                <input matInput [(ngModel)]="ballistic.Notes" name="Notes">
              </mat-form-field>
            </mat-grid-tile>

          </mat-grid-list>
        </form>
        <button mat-button (click)="deleteBallisticsRecord(ballistic)" style="color:red;" *ngIf="!ballistic.ID">DELETE</button>
      </mat-card>

      <button mat-button (click)="addBallisticsRecord('Cartridge Case')">+ Add Cartridge Case</button>
      <button mat-button (click)="addBallisticsRecord('Projectile')">+ Add Projectile</button>

      <mat-card class="mat-elevation-z0 custom_outline">
        <h5>
          Additional Cartridges / Projectiles can be added here but will not be linked to the subject of this hit.  Added Cartridge Cases / Projectiles will have the same fields as our data entry fields, they can be added or deleted at will.  Additional Cartridge Cases will be colored same as linked and mandatory once the add button is selected.  Additional Projectiles will be colored blue and all fields mandatory.  Any evidence lines that appear must be filled in order to save.
        </h5>
      </mat-card>
    </form>
  </mat-card>

</mat-card>

<mat-card style="margin-top: 20px;" class="mat-elevation-z0 custom_outline">
  <mat-card-header>
    <mat-card-title>PEOPLE DETAILS</mat-card-title>
  </mat-card-header>

  <form>
    <button mat-button (click)="addPersonRecord()" >+ Add Person</button>


    <mat-card *ngFor="let person of data.Persons" class="mat-elevation-z0 custom_outline" style="margin: 10px;">
      <form>
        <mat-grid-list cols="4" rowHeight="75px">

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightblue; border: 1px solid black; border-radius: 5px;">
              <mat-label>Role</mat-label>
              <mat-select [(value)]="person.Role">
                <mat-option value="INVESTIGATOR">
                  INVESTIGATOR
                </mat-option>

                <mat-option value="OTHER">
                  OTHER
                </mat-option>

                <mat-option value="SUSPECT">
                  SUSPECT
                </mat-option>

                <mat-option value="SUSPECT/VICTIM">
                  SUSPECT/VICTIM
                </mat-option>

                <mat-option value="VICTIM">
                  VICTIM
                </mat-option>

                <mat-option value="WITNESS">
                  WITNESS
                </mat-option>

              </mat-select>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightblue; border: 1px solid black; border-radius: 5px;">
              <mat-label>First Name</mat-label>
              <input matInput [(ngModel)]="person.FIRSTNAME"  [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
              <mat-label>MI</mat-label>
              <input matInput [(ngModel)]="person.MI"  [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightblue; border: 1px solid black; border-radius: 5px;">
              <mat-label>Last Name</mat-label>
              <input matInput [(ngModel)]="person.LASTNAME" [ngModelOptions]="{standalone: true}">
            </mat-form-field>

          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
              <mat-label>Suffix</mat-label>
              <input matInput [(ngModel)]="person.Suffix" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-grid-tile>


          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() !== 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
              <mat-label>SBI</mat-label>
              <input matInput [(ngModel)]="person.SBINo" [ngModelOptions]="{standalone: true}">
            </mat-form-field>

          </mat-grid-tile>


          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() !== 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
              <mat-label>FBI</mat-label>
              <input matInput [(ngModel)]="person.FBI" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() === 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightblue; border: 1px solid black; border-radius: 5px;">
              <mat-label>Email</mat-label>
              <input matInput [(ngModel)]="person.Email" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() === 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightblue; border: 1px solid black; border-radius: 5px;">
              <mat-label>Rank</mat-label>
              <input matInput [(ngModel)]="person.Rank"  [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() === 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightblue; border: 1px solid black; border-radius: 5px;">
              <mat-label>Phone</mat-label>
              <input matInput [(ngModel)]="person.Phone" [ngModelOptions]="{standalone: true}" mask="(000) 000-0000">
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1" *ngIf="person?.Role?.toUpperCase() !== 'Investigator'.toUpperCase()">
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightblue; border: 1px solid black; border-radius: 5px;">
              <mat-label>DOB</mat-label>

              <input matInput [matDatepicker]="PDOBDatePicker" [(ngModel)]="person.DOB" name="PDOB">
              <mat-datepicker-toggle matSuffix [for]="PDOBDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #PDOBDatePicker></mat-datepicker>
            </mat-form-field>

          </mat-grid-tile>


          <mat-grid-tile [colspan]="4" [rowspan]="1" dense>
            <mat-form-field appearance="fill" style="width: 100%; margin: 3px; background-color: lightgreen; border: 1px solid black; border-radius: 5px;">
              <mat-label>Notes</mat-label>
              <input matInput [(ngModel)]="person.AdditionalNotes" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
          </mat-grid-tile>
        </mat-grid-list>

        <button mat-button (click)="deletePersonRecord(person)" style="color:red;" *ngIf="!person.ID">DELETE</button>
      </form>
    </mat-card>

    <mat-card class="mat-elevation-z0 custom_outline">
      <h5>Any people listed in the initial Alert will be automatically populated in this area.  The fields will be as indicateby the color as mandatory or optional. </h5>
    </mat-card>
  </form>

</mat-card>


<div style="margin-top:25px; width: 100%; display: block; height: 50px;" >
  <span style="float: right;">
      <mat-checkbox [checked]="requestCopyOfReport" (change)="setRequestCopyCheck($event.checked)">
      Request Copy of Updated Report
    </mat-checkbox>
      <button mat-stroked-button style="background-color: yellow; border: black 3px solid; margin-left: 1em;" (click)="savedIncidentEditLink()">SUBMIT CHANGES</button>
  </span>
</div>


